import { render } from "./specialist.vue?vue&type=template&id=6401b65e&scoped=true"
import script from "./specialist.vue?vue&type=script&lang=js"
export * from "./specialist.vue?vue&type=script&lang=js"

import "./specialist.vue?vue&type=style&index=0&id=6401b65e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6401b65e"

export default script